import { MINI_APP_LINK, WE_CHAT_APP_ID } from './utils/constant';
import { HarmonyOSInfo } from './InternetBar.types';

export type StateCSS = {
  internetBarContent: string;
  internetBarContentContainer: string;
  internetBarContentDescriptionContainer: string;
  internetBarButtonContainer: string;
  internetBarButtonContentContainer: string;
  internetBarFooterContainer: string;
  internetBarIcon: string;
  internetBarNotWelcomeTitle: string;
  internetBarWelcomeText: string;
  internetBarDescription: string;
  internetBarSigninButton: string;
  internetBarJoinNowButton: string;
  internetBarConnectButton: string;
  internetBarTermsAndConditions: string;
  internetBarLoyaltyContainer: string;
  internetBarLoyaltyDescription: string;
  internetBarLoyaltySubDescription: string;
  internetBarLoyaltyButtons: string;
};

const STATE_CSS_INITIAL = {
  internetBarContent: '',
  internetBarContentContainer: '',
  internetBarContentDescriptionContainer: '',
  internetBarButtonContainer: '',
  internetBarButtonContentContainer: '',
  internetBarFooterContainer: '',
  internetBarIcon: '',
  internetBarNotWelcomeTitle: '',
  internetBarWelcomeText: '',
  internetBarDescription: '',
  internetBarSigninButton: '',
  internetBarJoinNowButton: '',
  internetBarConnectButton: '',
  internetBarTermsAndConditions: '',
  internetBarLoyaltyContainer: '',
  internetBarLoyaltyDescription: '',
  internetBarLoyaltySubDescription: '',
  internetBarLoyaltyButtons: '',
};

export const getInternetBarStateSpecificClasses = (
  userSegment: string,
  state: string,
  experienceSegment: string,
  enableLoyalty: boolean
): StateCSS => {
  const stateCSS = {
    ...STATE_CSS_INITIAL,
  };
  switch (state) {
    case 'in_stay':
      stateCSS.internetBarContent =
        userSegment === 'NOT Logged In'
          ? `internet-bar-content-${state}-signed-out`
          : `internet-bar-content-${state}-signed-in`;

      stateCSS.internetBarContentContainer =
        userSegment === 'NOT Logged In' ? '' : 'px-4 px-xl-0 pb-4 pb-xl-0 mb-4 mt-4 pt-2 mt-xl-0 pt-xl-1';
      stateCSS.internetBarIcon = 'my-4';
      stateCSS.internetBarNotWelcomeTitle = 'pb-2 mb-1 pb-xl-4 mb-xl-1 px-1 px-xl-0';
      stateCSS.internetBarContentDescriptionContainer =
        userSegment === 'NOT Logged In' ? 'pt-2 pt-xl-0' : 'pt-3 pt-xl-2';
      stateCSS.internetBarWelcomeText = 'mb-4';
      stateCSS.internetBarDescription = 'mb-4 pb-xl-3';
      stateCSS.internetBarButtonContentContainer = userSegment === 'NOT Logged In' ? 'mb-3 pb-xl-2' : '';
      stateCSS.internetBarSigninButton = 'm-button m-button-primary d-flex align-items-center justify-content-center';
      stateCSS.internetBarJoinNowButton = 'm-button-primary d-flex align-items-center justify-content-center';
      stateCSS.internetBarConnectButton = 'px-2 px-xl-0 mb-4 pb-xl-2';
      stateCSS.internetBarTermsAndConditions = 'pb-4 pb-xl-3 mb-xl-1';
      break;

    case 'connected':
      stateCSS.internetBarContentContainer = 'px-0 m-0 pt-xl-1 pt-2 pb-2 pb-xl-0';
      stateCSS.internetBarIcon = 'my-3';
      stateCSS.internetBarNotWelcomeTitle = 'pb-2 pb-xl-4 px-1 px-xl-0 mb-0 pt-xl-1';
      stateCSS.internetBarContentDescriptionContainer = 'pt-3 pt-xl-0 px-xl-4';
      stateCSS.internetBarWelcomeText = 'mb-4 mx-xl-3';
      stateCSS.internetBarDescription = `${experienceSegment.includes('-Unknown') ? 'mx-xl-3' : ''}`;
      stateCSS.internetBarSigninButton =
        experienceSegment === 'Connected-Elite-Tier1-Public-Bonvoy-RememberMe'
          ? 'm-button-secondary d-flex justify-content-center pt-2'
          : 'm-button-secondary d-flex justify-content-center pt-2';
      stateCSS.internetBarTermsAndConditions = 'pb-2 pb-xl-3';
      stateCSS.internetBarJoinNowButton = 'm-button-secondary d-flex justify-content-center';
      stateCSS.internetBarConnectButton = 'mb-2 px-2 px-xl-0 pb-xl-2 pt-2'; //mb-2 mt-3
      break;

    case 'upgrade':
      stateCSS.internetBarContentContainer =
        experienceSegment === 'Upgrade-Basic-UPrice-Public' ||
        experienceSegment === 'Upgrade-Elite-UPrice-Public-Device' ||
        experienceSegment === 'Upgrade-Elite-UPrice-Public-RememberMe' ||
        experienceSegment === 'Upgrade-Unknown-UPrice-Public'
          ? 'pt-xl-1 pt-2 pb-2 pb-xl-0'
          : 'pt-xl-1 pt-2 pb-3';
      stateCSS.internetBarIcon = 'my-3';
      stateCSS.internetBarNotWelcomeTitle = 'pb-4 mb-0 px-1 px-xl-0 pt-xl-1';
      stateCSS.internetBarContentDescriptionContainer = 'px-0 px-xl-4';
      stateCSS.internetBarWelcomeText = 'mb-4 mx-xl-3';
      stateCSS.internetBarDescription =
        experienceSegment.includes('RememberMe') || experienceSegment.includes('Unknown') ? 'mb-4 mx-xl-3' : '';

      stateCSS.internetBarButtonContentContainer =
        experienceSegment === 'Upgrade-Basic-UPrice-Public-Device' ||
        experienceSegment === 'Upgrade-Basic-UPrice-Public-RememberMe' ||
        experienceSegment === 'Upgrade-Elite-UPrice-Public-Device' ||
        experienceSegment === 'Upgrade-Elite-UPrice-Public-RememberMe' ||
        experienceSegment === 'Upgrade-Unknown-UPrice-Public'
          ? 'mb-3'
          : '';
      stateCSS.internetBarSigninButton =
        experienceSegment === 'Upgrade-Basic-UPrice-Public-Device' ||
        experienceSegment === 'Upgrade-Basic-UPrice-Public-RememberMe' ||
        experienceSegment === 'Upgrade-Elite-UPrice-Public-Device' ||
        experienceSegment === 'Upgrade-Elite-UPrice-Public-RememberMe'
          ? 'm-button-secondary mb-5 pt-2'
          : 'm-button-secondary pt-2 mb-3 mb-xl-2';
      stateCSS.internetBarJoinNowButton =
        experienceSegment === 'Upgrade-Unknown-UPrice-Public'
          ? 'm-button-secondary mb-5 pt-2'
          : experienceSegment === 'Upgrade-Unknown-Login' ||
            experienceSegment === 'Upgrade-Unknown-LoginError' ||
            experienceSegment === 'Upgrade-Unknown-UPrice-Guest'
          ? 'm-button-secondary mb-3 mb-xl-2'
          : 'm-button-secondary';
      stateCSS.internetBarConnectButton = 'm-button mb-2';
      stateCSS.internetBarTermsAndConditions = '';
      break;

    case 'upgraded':
      stateCSS.internetBarContentContainer = 'pt-xl-1 pt-2 pb-2 pb-xl-0';
      stateCSS.internetBarNotWelcomeTitle = 'pb-4 mb-0 px-1 px-xl-0 pt-xl-1';
      stateCSS.internetBarIcon = 'my-3';
      stateCSS.internetBarContentDescriptionContainer = 'px-0 px-xl-4';
      stateCSS.internetBarWelcomeText = 'mb-4 mx-xl-3';
      stateCSS.internetBarDescription =
        experienceSegment.includes('RememberMe') || experienceSegment.includes('Unknown') ? 'mb-4 mx-xl-3' : '';
      stateCSS.internetBarButtonContentContainer =
        experienceSegment === 'Upgraded-Basic-Device' ||
        experienceSegment === 'Upgraded-Basic-RememberMe' ||
        experienceSegment === 'Upgraded-Elite-Device' ||
        experienceSegment === 'Upgraded-Unknown'
          ? 'mb-3'
          : '';
      stateCSS.internetBarSigninButton =
        experienceSegment === 'Upgraded-Basic-Device' ||
        experienceSegment === 'Upgraded-Basic-RememberMe' ||
        experienceSegment === 'Upgraded-Elite-Device' ||
        experienceSegment === 'Upgraded-Elite-RememberMe'
          ? 'm-button-secondary mb-5 pt-2'
          : '';
      stateCSS.internetBarJoinNowButton =
        experienceSegment === 'Upgraded-Unknown' ? 'm-button-secondary mb-5 ' : 'm-button-secondary';
      stateCSS.internetBarConnectButton = 'px-2 px-xl-0 mb-4 pb-xl-2';
      stateCSS.internetBarTermsAndConditions = 'pb-4 pb-xl-3 mb-xl-1';
      break;

    case 'preconnect':
      stateCSS.internetBarNotWelcomeTitle = enableLoyalty ? 'pb-2 pb-md-4' : 'pb-2 mb-1 pb-xl-4 mb-xl-1 px-1 px-xl-0';
      stateCSS.internetBarIcon = enableLoyalty ? 'mt-5 mb-3' : 'my-4';
      stateCSS.internetBarContentDescriptionContainer = 'mb-3 pb-3 pb-xl-3 mb-xl-1 px-0 mx-xl-4';
      stateCSS.internetBarButtonContainer = 'px-0';
      stateCSS.internetBarButtonContentContainer = 'pb-3 px-xl-4 mx-xl-1';
      stateCSS.internetBarConnectButton = 'm-button';
      stateCSS.internetBarFooterContainer = userSegment === 'NOT Logged In' ? 'px-0' : 'px-0 pb-4 mb-1 mb-xl-0';
      stateCSS.internetBarTermsAndConditions = enableLoyalty ? 'pb-3 pb-md-4' : 'pb-4 pb-xl-3 mb-xl-1 t-font-xs';
      stateCSS.internetBarDescription =
        userSegment === 'NOT Logged In' &&
        (experienceSegment.includes('RememberMe') || experienceSegment.includes('Unknown'))
          ? 'mb-0'
          : '';
      break;
  }

  return stateCSS;
};

/**
 * Function to determine if the user is on a mobile device
 */
export const isMobile = (): boolean => {
  // handle server-side rendering case
  if (typeof navigator === 'undefined') {
    return false;
  }
  const userAgent = navigator.userAgent ?? navigator.vendor ?? window?.['opera'];
  const isTablet = !!(/Linux/i.test(userAgent) && navigator?.maxTouchPoints > 1);
  const isIpad = !!(/Macintosh/i.test(userAgent) && navigator?.maxTouchPoints < 6 && navigator?.maxTouchPoints > 0);
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) || isTablet || isIpad;
};

/**
 * Detect if running on iOS
 */
export const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * Detect if running in iOS captive portal
 */
export const isIOSCaptivePortal = () => {
  if (!isIOS()) return false;

  // Check for captive portal indicators
  const captiveIndicators = [
    navigator.onLine === false,
    document.visibilityState === 'hidden',
    window.location.hostname === 'captive.apple.com',
    window.location.hostname === 'www.apple.com',
    window.location.hostname === 'connectivitycheck.apple.com',
    window.location.hostname === 'connectivitycheck.gstatic.com',
    window.location.hostname === 'connectivitycheck.android.com',
    window.location.hostname === 'connectivitycheck.canonical.com',
    window.location.hostname === 'connectivitycheck.microsoft.com',
    window.location.hostname === 'connectivitycheck.nokia.com',
    window.location.hostname === 'connectivitycheck.vodafone.com',
  ];

  return captiveIndicators.some(indicator => indicator);
};

/**
 * Comprehensive HarmonyOS detection function
 * @returns HarmonyOSInfo object with detection results
 */
export const detectHarmonyOS = (): HarmonyOSInfo => {
  // Check if running in browser environment
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return {
      isHarmonyOS: false,
      version: null,
      type: null,
      isAndroidCompatible: false,
      userAgent: '',
    };
  }

  const userAgent = navigator.userAgent || '';
  const userAgentLower = userAgent.toLowerCase();

  // HarmonyOS detection patterns
  const harmonyOSPatterns = [
    /harmonyos[\s]?([\d.]+)/i, // HarmonyOS/4.0.0 or HarmonyOS 4.0.0
    /openharmony[\s]?([\d.]+)/i, // OpenHarmony/3.2.0
    /harmony[\s]?([\d.]+)/i, // Harmony/4.0
    /hos[\s]?([\d.]+)/i, // HOS/4.0 (short form)
  ];

  // Additional HarmonyOS indicators
  const harmonyOSIndicators = ['harmonyos', 'openharmony', 'hos', 'ohos', 'harmony'];

  let isHarmonyOS = false;
  let version: string | null = null;
  let type: 'NEXT' | 'ANDROID_COMPATIBLE' | 'UNKNOWN' | null = null;
  let isAndroidCompatible = false;

  // Check primary patterns
  for (const pattern of harmonyOSPatterns) {
    const match = userAgent.match(pattern);
    if (match) {
      isHarmonyOS = true;
      version = match[1] || null;
      break;
    }
  }

  // Fallback: Check for indicators if no version found
  if (!isHarmonyOS) {
    for (const indicator of harmonyOSIndicators) {
      if (userAgentLower.includes(indicator)) {
        isHarmonyOS = true;
        break;
      }
    }
  }

  // Determine HarmonyOS type and Android compatibility
  if (isHarmonyOS) {
    // Check if it's Android-compatible HarmonyOS
    const hasAndroid = userAgentLower.includes('android');
    const hasLinux = userAgentLower.includes('linux');

    if (hasAndroid) {
      type = 'ANDROID_COMPATIBLE';
      isAndroidCompatible = true;
    } else if (hasLinux && !hasAndroid) {
      // HarmonyOS NEXT typically shows Linux but not Android
      type = 'NEXT';
      isAndroidCompatible = false;
    } else {
      type = 'UNKNOWN';
      // Try to guess based on version
      if (version) {
        const majorVersion = parseInt(version.split('.')[0]);
        if (majorVersion >= 5) {
          type = 'NEXT'; // HarmonyOS 5+ is likely NEXT
          isAndroidCompatible = false;
        } else if (majorVersion === 4) {
          type = 'ANDROID_COMPATIBLE'; // HarmonyOS 4 is Android-compatible
          isAndroidCompatible = true;
        }
      }
    }
  }

  return {
    isHarmonyOS,
    version,
    type,
    isAndroidCompatible,
    userAgent,
  };
};

/**
 * Simple boolean check for HarmonyOS
 * @returns boolean indicating if running on HarmonyOS
 */
export const isHarmonyOS = (): boolean => {
  return detectHarmonyOS().isHarmonyOS;
};

/**
 * Simple boolean check for HarmonyOS and is Android Compatible
 * @returns boolean indicating if running on HarmonyOS and is Android Compatible
 */
export const isHarmonyOSAndroidCompatible = (): boolean => {
  return detectHarmonyOS().isAndroidCompatible;
};

export const getUpdatedMiniAppLink = (weChatEnrollmentSourceCode: string, datalayer: Record<string, unknown> = {}) => {
  const miniAppLink = MINI_APP_LINK;
  const marsha: string = (datalayer?.['mrshaCode'] ?? '') as string;
  const updatedMiniAppLink = miniAppLink
    ?.replace('__WE_CHAT_APP_ID__', WE_CHAT_APP_ID)
    ?.replace('__MARSHA__', marsha?.toUpperCase())
    ?.replace('__ENROLLMENT_SRC_CODE__', weChatEnrollmentSourceCode?.toUpperCase());
  return updatedMiniAppLink;
};

export const openWeChatScheme = (weChatEnrollmentCode: string) => {
  // This will attempt to open WeChat via URL scheme
  const scheme = getUpdatedMiniAppLink(weChatEnrollmentCode);
  const a = document.createElement('a');
  a.href = scheme;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // Clean up
  setTimeout(() => {
    document.body.removeChild(a);
  }, 1000);
};

export const navigateToWeChat = (weChatEnrollmentSourceCode: string, datalayer: Record<string, unknown> = {}) => {
  const updatedMiniAppLink = getUpdatedMiniAppLink(weChatEnrollmentSourceCode, datalayer);
  window.open(updatedMiniAppLink, '_self');
};
